import React, { useState, useRef } from 'react';
import RadioGroup from 'devextreme-react/radio-group';
import {formatMessage} from "devextreme/localization";
import TextBox from "devextreme-react/text-box";
import Validator, {RequiredRule, EmailRule} from "devextreme-react/validator";
import {formatMessageExt} from "../../utils/helpers";

const YONTEM_SMS = 'sms';
const YONTEM_MAIL = 'mail';

const items = [
    {value : YONTEM_SMS, text: formatMessage('dogrulamaSms')},
    {value : YONTEM_MAIL, text: formatMessage('dogrulamaMail')}
];

const MASK_GSM = '\\0 (000) 000 00 00';


export default function ({ disabled, setInputValues, defaultValue, caption }) {
    const [yontem, setYontem] = useState(items[0].value)
    const refDogrulama = useRef(null);

    const yontem_onValueChanged = (e) => {
        if (refDogrulama.current && refDogrulama.current.instance) {
            refDogrulama.current.instance.reset();
        }
        if (setInputValues) {
            setInputValues({ yontem: e.value, dogrulama: '' })
        }
        setYontem(e.value);
    }

    const dogrulama_onValueChanged = (e) => {
        if (setInputValues) {
            setInputValues({ yontem, dogrulama: e.value })
        }
    };

    const yontemSms = yontem === YONTEM_SMS;

    return <div>
        <div>{caption ? caption : formatMessage('dogrulamaYontemi')}</div>

        <br/>
        <RadioGroup items={items}
                    defaultValue={yontem}
                    displayExpr="text"
                    valueExpr="value"
                    readOnly={disabled}
                    onValueChanged={yontem_onValueChanged}
                    layout="horizontal" />
                    <br/>
        <TextBox placeholder={yontem === "sms"
                ? formatMessage('kayitliGSMNumaraniz')
                : formatMessage('kayitliKisiselEmail')}
                 readOnly={disabled}
                 mask={yontemSms ? MASK_GSM : null}
                 maskInvalidMessage={yontemSms ? formatMessageExt('validation.notValid', ['cepTelefonu']) : null}
                 ref={refDogrulama}
                 defaultValue={defaultValue}
                 autoComplete="off"
                 //onKeyDown={loginName_onKeyDown}
                 //valueChangeEvent="keyup"
                 onValueChanged={dogrulama_onValueChanged}
                 stylingMode={'filled'}>
            <Validator>
                <RequiredRule
                    message={formatMessageExt('validation.isRequired',
                        [yontemSms ? 'cepTelefonu' : 'email'])} />
                {!yontemSms && <EmailRule message={formatMessageExt('validation.notValid', ['email'])} />}
            </Validator>
        </TextBox>
    </div>
}